/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import CustomToolBar from "../../../ToolBar/customToolbar"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  prevForm,
  nextForm,
} from "../../../utils/utils"
import ServicesRow from "../../B/PlannedServices/ServicesRow"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import { InputText } from "primereact/inputtext"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"

const ServicesReceived4 = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadPrev,
    handleLoadNext,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    administrativeInterview,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [servicesReceived4, setServicesReceived4] = useState(
    interview[INTERVIEW_SECTIONS.SERVICES_RECEIVED_4]
  )
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])
  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) =>
            q.section === INTERVIEW_SECTIONS.SERVICES_RECEIVED_4 &&
            !q.field.endsWith("section")
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.SERVICES_RECEIVED_4
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(
      INTERVIEW_SECTIONS.SERVICES_RECEIVED_4,
      servicesReceived4
    )
    if (previousForm) {
      handleLoadPrev(true)
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_SERVICESRECEIVED4_DATA, {
          GpraKEs1: servicesReceived4?.gpra_k_es_1,
          GpraKEs2: servicesReceived4?.gpra_k_es_2,
          GpraKEs3: servicesReceived4?.gpra_k_es_3,
          GpraKEs4: servicesReceived4?.gpra_k_es_4,
          GpraKEs5: servicesReceived4?.gpra_k_es_5,
          GpraKEs6: servicesReceived4?.gpra_k_es_6,
          GpraKEs7: servicesReceived4?.gpra_k_es_7,
          GpraKEs7a: servicesReceived4?.gpra_k_es_7a,
          GpraKPtp1: servicesReceived4?.gpra_k_ptp_1,
          GpraKPtp2: servicesReceived4?.gpra_k_ptp_2,
          GpraKPtp3: servicesReceived4?.gpra_k_ptp_3,
          GpraKPtp4: servicesReceived4?.gpra_k_ptp_4,
          GpraKPtp5: servicesReceived4?.gpra_k_ptp_5,
          GpraKPtp6: servicesReceived4?.gpra_k_ptp_6,
          GpraKPtp7: servicesReceived4?.gpra_k_ptp_7,
          GpraKPtp8: servicesReceived4?.gpra_k_ptp_8,
          GpraKPtp8a: servicesReceived4?.gpra_k_ptp_8a,
          GpraKPtp9: servicesReceived4?.gpra_k_ptp_9,
          GpraKPtp9a: servicesReceived4?.gpra_k_ptp_9a,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraKId: servicesReceived4?.gpra_k_id,
          Additional: getAdditionalQuestions(servicesReceived4),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              handleLoadNext(false)
              setNextForm(
                nextForm(sections, activeIndex, administrativeInterview)
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ servicesReceived4: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (
      servicesReceived4?.gpra_k_es_7 > 0 &&
      !servicesReceived4?.gpra_k_es_7a &&
      showQuestion(questions, "gpra_k_es_7")
    ) {
      errors.gpra_k_es_7a = errorMessages.requiredMessage
    }
    if (
      servicesReceived4?.gpra_k_ptp_8 > 0 &&
      !servicesReceived4?.gpra_k_ptp_8a &&
      showQuestion(questions, "gpra_k_ptp_8")
    ) {
      errors.gpra_k_ptp_8a = errorMessages.requiredMessage
    }
    if (
      servicesReceived4?.gpra_k_ptp_9 > 0 &&
      !servicesReceived4?.gpra_k_ptp_9a &&
      showQuestion(questions, "gpra_k_ptp_9")
    ) {
      errors.gpra_k_ptp_9a = errorMessages.requiredMessage
    }
    setValidationErrors(
      validateQuestions(
        servicesReceived4,
        INTERVIEW_SECTIONS.SERVICES_RECEIVED_4,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const renderDefaultMain = (question) => {
    if (question.field === "gpra_k_es_1") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel label={`${question.number}. Education Services`} />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`1. Substance Abuse Education`}
              number={servicesReceived4?.gpra_k_es_1}
              setNumber={"gpra_k_es_1"}
              numberError={validationErrors.gpra_k_es_1}
              numberErrorType="gpra_k_es_1"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`2. HIV/AIDS Education`}
              number={servicesReceived4?.gpra_k_es_2}
              setNumber={"gpra_k_es_2"}
              numberError={validationErrors.gpra_k_es_2}
              numberErrorType="gpra_k_es_2"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`3. Naloxone Training`}
              number={servicesReceived4?.gpra_k_es_3}
              setNumber={"gpra_k_es_3"}
              numberError={validationErrors.gpra_k_es_3}
              numberErrorType="gpra_k_es_3"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`4. Fentanyl Test Strip Training`}
              number={servicesReceived4?.gpra_k_es_4}
              setNumber={"gpra_k_es_4"}
              numberError={validationErrors.gpra_k_es_4}
              numberErrorType="gpra_k_es_4"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`5. Viral Hepatitis Education`}
              number={servicesReceived4?.gpra_k_es_5}
              setNumber={"gpra_k_es_5"}
              numberError={validationErrors.gpra_k_es_5}
              numberErrorType="gpra_k_es_5"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`6. Other STI Education Services`}
              number={servicesReceived4?.gpra_k_es_6}
              setNumber={"gpra_k_es_6"}
              numberError={validationErrors.gpra_k_es_6}
              numberErrorType="gpra_k_es_6"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`7. Other Education Services (Specify)`}
              number={servicesReceived4?.gpra_k_es_7}
              setNumber={"gpra_k_es_7"}
              numberError={validationErrors.gpra_k_es_7}
              numberErrorType="gpra_k_es_7"
              summaryDisabled={disabled}
              extraValues={[{ key: "gpra_k_es_7a", value: "" }]}
              defaultZero={question.defaultZero}
            />
          </div>
          {servicesReceived4?.gpra_k_es_7 > 0 && (
            <div className={gpraStyles.formRow}>
              <InputText
                className={
                  validationErrors.gpra_k_es_7a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={disabled}
                placeholder={
                  !servicesReceived4?.gpra_k_es_7 ? "Not Applicable" : ""
                }
                value={servicesReceived4?.gpra_k_es_7a}
                onChange={(e) => {
                  updateState(
                    "gpra_k_es_7",
                    e.target.value,
                    null,
                    null,
                    servicesReceived4,
                    setServicesReceived4,
                    null
                  )
                  removeError("gpra_k_es_7a")
                }}
              />
              <FormError error={validationErrors.gpra_k_es_7a} />
            </div>
          )}
        </>
      )
    }
    if (question.field === "gpra_k_ptp_1") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Peer-To-Peer Recovery Support Services`}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`1. Peer Coaching Or Mentoring`}
              number={servicesReceived4?.gpra_k_ptp_1}
              setNumber={"gpra_k_ptp_1"}
              numberError={validationErrors.gpra_k_ptp_1}
              numberErrorType="gpra_k_ptp_1"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`2. Vocational Services`}
              number={servicesReceived4?.gpra_k_ptp_2}
              setNumber={"gpra_k_ptp_2"}
              numberError={validationErrors.gpra_k_ptp_2}
              numberErrorType="gpra_k_ptp_2"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`3. Recovery Housing`}
              number={servicesReceived4?.gpra_k_ptp_3}
              setNumber={"gpra_k_ptp_3"}
              numberError={validationErrors.gpra_k_ptp_3}
              numberErrorType="gpra_k_ptp_3"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`4. Recovery Planning`}
              number={servicesReceived4?.gpra_k_ptp_4}
              setNumber={"gpra_k_ptp_4"}
              numberError={validationErrors.gpra_k_ptp_4}
              numberErrorType="gpra_k_ptp_4"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`5. Case Management Services to Specifically Support Recovery`}
              number={servicesReceived4?.gpra_k_ptp_5}
              setNumber={"gpra_k_ptp_5"}
              numberError={validationErrors.gpra_k_ptp_5}
              numberErrorType="gpra_k_ptp_5"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`6. Alcohol- and Drug-Free Social Activities`}
              number={servicesReceived4?.gpra_k_ptp_6}
              setNumber={"gpra_k_ptp_6"}
              numberError={validationErrors.gpra_k_ptp_6}
              numberErrorType="gpra_k_ptp_6"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`7. Information and Referral`}
              number={servicesReceived4?.gpra_k_ptp_7}
              setNumber={"gpra_k_ptp_7"}
              numberError={validationErrors.gpra_k_ptp_7}
              numberErrorType="gpra_k_ptp_7"
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`8. Other Recovery Support Services`}
              number={servicesReceived4?.gpra_k_ptp_8}
              setNumber={"gpra_k_ptp_8"}
              numberError={validationErrors.gpra_k_ptp_8}
              numberErrorType="gpra_k_ptp_8"
              summaryDisabled={disabled}
              extraValues={[{ key: "gpra_k_ptp_8a", value: "" }]}
              defaultZero={question.defaultZero}
            />
          </div>
          {servicesReceived4?.gpra_k_ptp_8 > 0 && (
            <div className={gpraStyles.formRow}>
              <InputText
                className={
                  validationErrors.gpra_k_ptp_8a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={disabled}
                placeholder={
                  !servicesReceived4?.gpra_k_ptp_8 ? "Not Applicable" : ""
                }
                value={servicesReceived4?.gpra_k_ptp_8a}
                onChange={(e) => {
                  updateState(
                    "gpra_k_ptp_8a",
                    e.target.value,
                    null,
                    null,
                    servicesReceived4,
                    setServicesReceived4,
                    null
                  )
                  removeError("gpra_k_ptp_8a")
                }}
              />
              <FormError error={validationErrors.gpra_k_ptp_8a} />
            </div>
          )}
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived4}
              setEntity={setServicesReceived4}
              showDrop={false}
              removeError={removeError}
              label={`9. Other Peer-to-Peer Recovery Support Services`}
              number={servicesReceived4?.gpra_k_ptp_9}
              setNumber={"gpra_k_ptp_9"}
              numberError={validationErrors.gpra_k_ptp_9}
              numberErrorType="gpra_k_ptp_9"
              summaryDisabled={disabled}
              extraValues={[{ key: "gpra_k_ptp_9a", value: "" }]}
            />
          </div>
          {servicesReceived4?.gpra_k_ptp_9 > 0 && (
            <div className={gpraStyles.formRow}>
              <InputText
                className={
                  validationErrors.gpra_k_ptp_9a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={disabled}
                placeholder={
                  !servicesReceived4?.gpra_k_ptp_9 ? "Not Applicable" : ""
                }
                value={servicesReceived4?.gpra_k_ptp_9a}
                onChange={(e) => {
                  updateState(
                    "gpra_k_ptp_9a",
                    e.target.value,
                    null,
                    null,
                    servicesReceived4,
                    setServicesReceived4,
                    null
                  )
                  removeError("gpra_k_ptp_9a")
                }}
              />
              <FormError error={validationErrors.gpra_k_ptp_9a} />
            </div>
          )}
        </>
      )
    }
  }
  
  return (
    <>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              toast={toast}
              prevForm={true}
              saveData={saveData}
              nextForm={true}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="K. SERVICES RECEIVED UNDER GRANT FUNDING"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default" && question.show) {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={servicesReceived4}
                    setEntity={setServicesReceived4}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.SERVICES_RECEIVED_4}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, servicesReceived4)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={servicesReceived4}
                      setEntity={setServicesReceived4}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.SERVICES_RECEIVED_4}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mt2}
          right={
            <CustomToolBar
              toast={toast}
              prevForm={true}
              saveData={saveData}
              nextForm={true}
            />
          }
        ></Toolbar>
      )}
    </>
  )
}

ServicesReceived4.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

ServicesReceived4.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default ServicesReceived4
